import { forwardRef } from "react";
import { CardContainer } from "./index.styled";
import CampaignSummaryItem from "../CampaignSummaryItem";
import usersIcon from "../../../../assets/icons/user-blue.webp";

interface CampaignOption {
  id: number;
  label: string;
  value: number;
}

interface CampaignSummaryCardProps {
  options: CampaignOption[];
}

const CampaignSummaryCard = forwardRef<
  HTMLDivElement,
  CampaignSummaryCardProps
>(({ options }, ref) => {
  const maxValue = Math.max(...options.map((option) => option.value));

  return (
    <CardContainer ref={ref}>
      <div className="options-container">
        <img src={usersIcon} alt="users" className="card-icon" />
        {options.map((option) => (
          <CampaignSummaryItem
            key={option.id}
            label={option.label}
            value={option.value}
            maxValue={maxValue}
          />
        ))}
      </div>
    </CardContainer>
  );
});

CampaignSummaryCard.displayName = "CampaignSummaryCard";

export default CampaignSummaryCard;
